module.exports = __webpack_public_path__ + "img/check.b07ca9cd.svg";